import { ThemeProvider } from "@mui/material/styles";
import luTheme from "./luTheme";

export default function AppThemeProvider({ children }) {
  return <ThemeProvider theme={luTheme}>{children}</ThemeProvider>;
}
